/**
 * School gallery categories — admin dropdown + public filters (single source).
 * Purane DB values (Infrastructure, Activities, General) filter/display me map ho jate hain.
 */

export const GALLERY_CATEGORIES = [
  {
    value: 'Events',
    hint: 'Annual function, assemblies, school programs',
  },
  {
    value: 'Sports',
    hint: 'Sports day, matches, yoga, PT',
  },
  {
    value: 'Campus & Facilities',
    hint: 'Building, classroom, library, playground — lab photos ke liye neeche wali Lab categories',
  },
  {
    value: 'Science Labs',
    hint: 'Physics Lab, Chemistry Lab, Biology Lab — room ya practical dono',
  },
  {
    value: 'Computer & IT Lab',
    hint: 'Computer lab, smart class, coding / robotics activity',
  },
  {
    value: 'Academics',
    hint: 'Classroom learning, projects, science fair (lab ke bahar)',
  },
  {
    value: 'Arts & Co-curricular',
    hint: 'Music, dance, art, clubs, hobbies',
  },
  {
    value: 'Festivals & Celebrations',
    hint: 'Independence Day, Diwali, special days',
  },
  {
    value: 'Achievements',
    hint: 'Awards, trophies, competitions',
  },
  {
    value: 'Community & Outreach',
    hint: 'Social work, parent events, tours',
  },
];

export const DEFAULT_GALLERY_CATEGORY = 'Events';

/** Public filter tabs (All + every category value) */
export const GALLERY_FILTER_TABS = ['All', ...GALLERY_CATEGORIES.map((c) => c.value)];

/** Purani photos / import — purane naam naye tabs ke saath match */
const LEGACY_CATEGORY_MAP = {
  Infrastructure: 'Campus & Facilities',
  Activities: 'Arts & Co-curricular',
  General: 'Events',
};

export function normalizeGalleryCategory(category) {
  const raw = (category || '').trim();
  if (!raw) return DEFAULT_GALLERY_CATEGORY;
  return LEGACY_CATEGORY_MAP[raw] || raw;
}

export function galleryCategoryMatchesFilter(imageCategory, filterTab) {
  if (filterTab === 'All') return true;
  return normalizeGalleryCategory(imageCategory) === filterTab;
}

/** Admin: title me exact lab ka naam likho — category se filter, title se pehchan */
export const GALLERY_LAB_TITLE_EXAMPLES = [
  'Physics Lab',
  'Chemistry Lab',
  'Biology Lab',
  'Composite Science Lab',
  'Computer Lab',
  'Smart Classroom',
  'Robotics / ATL Lab',
  'Maths Lab',
  'Language Lab',
];

export function isGalleryLabCategory(category) {
  const c = normalizeGalleryCategory(category);
  return c === 'Science Labs' || c === 'Computer & IT Lab';
}
